<template>
  <div>
    <DashboardHeader title="Marks Schedule">
      <v-layout row wrap>
        <v-flex xs12 md2 v-if="isAdmin">
          <v-card
            :color="getThemeColor"
            dark
            class="mr-2 ml-4 mt-2 px-4"
            shaped
            elevation="12"
            max-width="200"
            outlined
            v-for="(subject,sk) in subjects"
            :key="sk+Math.random()"
          >
            <v-text-field
              :label="subject.title"
              @change="openStreamLabelDialog(subject.key)"
              class="my-0"
            ></v-text-field>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-btn
                  style="display:inline-block;float:left"
                  rounded
                  class="mt-1 ml-2 mr-2"
                  color="red"
                  @click="captureMarksNow(subject)"
                  x-small
                >Capture Marks</v-btn>
                <v-checkbox
                  dense
                  class="shrink ml-4 mt-0"
                  @change="updateSubjectHeaders()"
                  :value="subject.key"
                  v-model="selectedHeaders"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md10 class="mt-4" style="margin:0px" v-if="isStaff">
          <v-card class="mt-4">
            <v-row>
              <span class="mx-6 mt-4">Class: {{selectedClass}}</span>
              <span class="mx-6 mt-4">Year: {{reportYear}}</span>
              <span
                class="mx-6 mt-4"
                v-if="selectedReportTerm"
              >Term: {{selectedReportTerm.toUpperCase()}}</span>
              <br />
              <span class="mt-0">
                <v-text-field
                  label="Date School Closes"
                  class="mb-6 mt-0"
                  v-model="dsc"
                  @change="updateDates()"
                ></v-text-field>
              </span>

              <span class="mt-0 ml-4">
                <v-text-field
                  label="Date School Re-Opens"
                  class="mb-6 mt-0"
                  v-model="dsrop"
                  @change="updateDates()"
                ></v-text-field>
              </span>

              <v-spacer></v-spacer>
              <v-text-field
                class="mt-0 mx-6 mb-6"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="display:inline"
              ></v-text-field>
            </v-row>

            <v-data-table :headers="headers" :items="marks" :search="search">
              <template v-slot:item.profile="{item}">
                <v-icon :color="getThemeColor" @click="viewProfile(item)">mdi-account-circle</v-icon>
              </template>
              <!-- <template v-slot:item.sub_1="{item}">
                <v-text-field @change="updateField(item.id,'sub_1')" v-model="item.sub_1"></v-text-field>
              </template>
              <template v-slot:item.sub_2="{item}">
                <v-text-field @change="updateField(item.id,'sub_2')" v-model="item.sub_2"></v-text-field>
              </template>
              <template v-slot:item.sub_3="{item}">
                <v-text-field @change="updateField(item.id,'sub_3')" v-model="item.sub_3"></v-text-field>
              </template>
              <template v-slot:item.sub_4="{item}">
                <v-text-field @change="updateField(item.id,'sub_4')" v-model="item.sub_4"></v-text-field>
              </template>
              <template v-slot:item.sub_5="{item}">
                <v-text-field @change="updateField(item.id,'sub_5')" v-model="item.sub_5"></v-text-field>
              </template>
              <template v-slot:item.sub_6="{item}">
                <v-text-field @change="updateField(item.id,'sub_6')" v-model="item.sub_6"></v-text-field>
              </template>
              <template v-slot:item.sub_7="{item}">
                <v-text-field @change="updateField(item.id,'sub_7')" v-model="item.sub_7"></v-text-field>
              </template>
              <template v-slot:item.sub_8="{item}">
                <v-text-field @change="updateField(item.id,'sub_8')" v-model="item.sub_8"></v-text-field>
              </template>
              <template v-slot:item.sub_9="{item}">
                <v-text-field @change="updateField(item.id,'sub_9')" v-model="item.sub_9"></v-text-field>
              </template>
              <template v-slot:item.sub_10="{item}">
                <v-text-field @change="updateField(item.id,'sub_10')" v-model="item.sub_10"></v-text-field>
              </template>
              <template v-slot:item.sub_11="{item}">
                <v-text-field @change="updateField(item.id,'sub_11')" v-model="item.sub_11"></v-text-field>
              </template>
              <template v-slot:item.sub_12="{item}">
                <v-text-field @change="updateField(item.id,'sub_12')" v-model="item.sub_12"></v-text-field>
              </template>-->
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" width="800" persistent>
        <v-card v-if="applytoOthers">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2 mb-6"
          >Apply Subject Label To Other Classess</v-card-title>

          <span class="my-12 ml-6 title">Subject {{streamColumn.split('_')[1]}} =></span>
          <span class="mb-12 mx-4 title">To Be Labelled As: " {{streamLabel}} " For Selected Classes</span>

          <v-layout row wrap class="mx-2 mt-6">
            <v-flex xs4 md4 v-for="(cls,inc) in classes" :key="inc+Math.random()">
              <v-card width="200" class="ml-4 mb-2 pl-4" :color="getThemeColor" shaped dark>
                <v-checkbox
                  class="shrink"
                  @change="getSelections()"
                  :value="cls.class_name"
                  v-model="selectedClasses"
                ></v-checkbox>
                <span>{{cls.class_name}}</span>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="updateStreamLabels()">Apply Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
export default {
  components: {
    DashboardHeader
  },
  computed: {
    getMarksScheduleParams() {
      return this.$store.getters.getMarksScheduleParams;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },

    getUserSchool() {
      return this.$store.getters.getUserSchool;
    }
  },
  mounted() {
    this.students = this.getMarksScheduleParams.selectedStudents;
    this.reportYear = this.getMarksScheduleParams.reportYear;
    this.selectedReportTerm = this.getMarksScheduleParams.selectedReportTerm;
    this.dsc = this.getMarksScheduleParams.dsc;
    this.dsrop = this.getMarksScheduleParams.dsrop;
    this.selectedClass = this.getMarksScheduleParams.selectedClass;
    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/initialise-marks-table",
        {
          selectedStudents: this.students,
          reportYear: this.reportYear,
          selectedReportTerm: this.selectedReportTerm,
          dsc: this.dsc,
          dsrop: this.dsrop,
          selectedClass: this.selectedClass
        },
        this.getAccessToken
      )
      .then(marks => {
        this.marks = marks;
        this.dsc = marks[0].dsc;
        this.dsrop = marks[0].dsrop;
        axios
          .postDataWithToken(
            "/auth/get-or-set-stream-for-selected-class",
            { selectedClass: this.selectedClass },
            this.getAccessToken
          )
          .then(stream => {
            this.refreshLabel(stream);
            this.$store.commit("setLoader", false);
          });
      });
    axios
      .getData("/auth/get-all-classes", this.getAccessToken)
      .then(classes => {
        this.classes = classes;
      });
  },
  data: () => ({
    selectedHeaders: [
      "sub_1",
      "sub_2",
      "sub_3",
      "sub_4",
      "sub_5",
      "sub_6",
      "sub_7",
      "sub_8",
      "sub_9",
      "sub_10",
      "sub_11",
      "sub_12"
    ],
    applytoOthers: false,
    classes: [],
    selectedClasses: [],
    streamLabel: null,
    streamColumn: null,
    studentID: null,
    subjects: [],
    stream: null,
    marks: [],
    selectedDate: new Date().toISOString().substr(0, 10),
    schoolEmis: null,
    datePicker: new Date().toISOString().substr(0, 10),
    reportYear: new Date().getFullYear(),
    dialog: false,
    feeIDs: [],
    selectedReportTerm: null,
    dsc: new Date().toISOString().substr(0, 10),
    dsrop: new Date().toISOString().substr(0, 10),
    blockReport: false,
    selectAll: false,
    selectedClass: null,
    selectedTerm: null,
    students: [],
    nameRules: [v => !!v || "Field is required"],

    showActionButtons: false,
    search: null,
    selectedStudents: [],
    allSelected: [],
    headStart: [
      { text: "Profile", value: "profile" },
      {
        text: "SID",
        align: "start",
        value: "sid"
      },
      { text: "Surname", value: "student.lname" },
      { text: "First Names", value: "student.fname" }
    ],
    headers: []
  }),
  methods: {
    getSelectedDate(selectedDate) {
      this.selectedDate = selectedDate;
    },

    updateField(id, column) {
      const value = event.target.value;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "marks", id, column, value },
          this.getAccessToken
        )
        .then(response => {
          const nothing = response;
        });
    },
    openStreamLabelDialog(column) {
      this.streamLabel = event.target.value;
      this.streamColumn = column;
      this.applytoOthers = true;
      this.selectedClasses.push(this.selectedClass);
      this.dialog = true;
    },
    closeDialog() {
      this.applytoOthers = false;
      this.dialog = false;
    },
    getSelections() {
      //console.log(this.selectedClasses);
    },
    updateStreamLabels() {
      const id = this.stream.id;

      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/update-stream",
          {
            id,
            column: this.streamColumn,
            value: this.streamLabel,
            classes: this.selectedClasses
          },
          this.getAccessToken
        )
        .then(stream => {
          this.streamColumn = null;
          this.streamLabel = null;
          this.selectedClasses = [];
          this.closeDialog();
          this.refreshLabel(stream);
          this.$store.commit("setLoader", false);
        });
    },
    updateSubjectHeaders() {
      const labels = Object.entries(this.stream);
      this.headers = [];
      this.headers = [...this.headStart];

      labels.forEach(subject => {
        if (
          subject[0] != "id" &&
          subject[0] != "classs" &&
          subject[0] != "emis" &&
          this.selectedHeaders.includes(subject[0])
        ) {
          this.headers.push({ text: subject[1], value: subject[0] });
        }
      });
    },
    refreshLabel(label) {
      this.stream = label;
      const labels = Object.entries(label);
      this.headers = [];
      this.subjects = [];
      this.headers = [...this.headStart];
      labels.forEach(subject => {
        if (
          subject[0] != "id" &&
          subject[0] != "classs" &&
          subject[0] != "emis"
        ) {
          this.headers.push({ text: subject[1], value: subject[0] });
          this.subjects.push({ title: subject[1], key: subject[0] });
        }
      });
    },

    viewProfile(item) {
      this.$router.push({ name: "student-profile", params: { sid: item.sid } });
    },
    captureMarksNow(subject) {
      this.$router.push({
        name: "capture-marks",
        params: { subject, classes: this.classes }
      });
    },
    updateDates() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/update-term-dates-on-schedule",
          {
            dsc: this.dsc,
            dsrop: this.dsrop,
            selectedReportTerm: this.selectedReportTerm,
            selectedClass: this.selectedClass,
            reportYear: this.reportYear
          },
          this.getAccessToken
        )
        .then(response => {
          this.$store.commit("setLoader", false);
        });
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/bulk-delete-students",
          {
            table: "students",
            sids: this.selectedStudents,
            selectedClass: this.selectedClass
          },
          this.getAccessToken
        )
        .then(students => {
          this.selectedStudents = [];
          this.snackbarText = "Selected Students Successfully Deleted!";
          this.snackbarColor = "success";
          this.students = students;
          this.$store.commit("setLoader", false);
          this.closeDialog();
          this.snackbarModel = true;
        });
    }
  }
};
</script>

<style>
</style>